// Единые ключи localStorage для access/refresh токенов (общие для user и admin).
export const USER_TOKEN_KEY         = 'user_access_token';
export const USER_REFRESH_TOKEN_KEY = 'user_refresh_token';

/**
 * Достаёт claim `roles` из payload OIDC access-токена (JWT, RS256), без проверки
 * подписи. Непустой набор ролей = доступ к админ-панели (та же семантика, что и
 * в backend authMiddleware). Это лишь UI-подсказка — backend проверяет токен сам.
 */
function decodeTokenClaim(token: string | null | undefined, claim: 'roles' | 'permissions'): string[] {
  if (!token) return [];
  try {
    const part = token.split('.')[1] ?? '';
    const b64  = part.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(part.length / 4) * 4, '=');
    const payload = JSON.parse(atob(b64)) as Record<string, unknown>;
    return Array.isArray(payload[claim]) ? (payload[claim] as string[]) : [];
  } catch {
    return [];
  }
}

export function decodeTokenRoles(token: string | null | undefined): string[] {
  return decodeTokenClaim(token, 'roles');
}

/**
 * Достаёт claim `permissions` из payload OIDC access-токена (без проверки подписи).
 * Используется только для UI-гейтинга (показ пунктов меню) — backend всё равно
 * проверяет права сам через requirePermission.
 */
export function decodeTokenPermissions(token: string | null | undefined): string[] {
  return decodeTokenClaim(token, 'permissions');
}

/** Событие window: запрос получил 401, и тихое обновление токена не помогло. */
export const AUTH_EXPIRED_EVENT = 'auth:expired';
